// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3OLqN","tab":"Tabs_tab__1TU9B","tabActive":"Tabs_tabActive__2Dw9t"};